/*
 * Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import { LinearProgress } from "@mui/material";
import { formatBytes } from "./format.js";
// icons
import { ReactComponent as XmarkIcon } from "assets/images/icons/xmark-solid-full.svg";
// import XmarkIcon from "assets/images/icons/xmark-solid-full.svg";

/**
 * @type {import("react").FC<UploadingFileProps>}
 */
const UploadingFile = (props) => {

    const file = props?.file;
    const onCancelFile = props?.onCancelFile;
    const filename = file?.name ?? file?.filename;
    const size = file?.size;

    // const fileName = getAcceptableFilename(file);

    const onCancelUpload = (event, _file) => {
        event.stopPropagation();

        // remove file from upload list
        if (typeof onCancelFile === "function") {
            onCancelFile(_file);
        }

        // FIXME: we are leaving a file in azure storage.
        //   - TODO: actually cancel network request
        //   - TODO: make delete request to api
        //   - TODO:    make delete request to storage from the api
        //      See AbortController
        //        may also solve "progress"
        //      https://stackoverflow.com/questions/65678404/how-to-cancel-azure-blob-upload-multiple-files
    };

    return (
        <div className="entity-file-upload-file-listing">
            <div className="progress-bar-container">
                <LinearProgress variant="indeterminate" color="primary" />
            </div>
            <div className="entity-file-upload-control-bar">
                <div className="entity-file-title">
                    <div>
                        {filename} ({formatBytes(size)})
                    </div>
                </div>
                <div className="entity-deleteIcon" onClick={(event) => onCancelUpload(event, file)}>
                    <span className="entity-icon-container">
                        <XmarkIcon
                            alt="information"
                            className="entity-icon"
                        />
                    </span>
                    <span>Cancel</span>
                </div>
            </div>
        </div>
    );
};

UploadingFile.displayName = "UploadingFile";
export { UploadingFile };


/**
 * @typedef {object} UploadingFileProps
 * @property {File} file
 * @property {(file: File) => void} onCancelFile
 */
